<!--  -->
<template>
  <div style="padding:20px">
    <div class="search_box">
      <div>
        <el-input v-model="pageIfon.chat_id" style="width:200px;margin-right:10px" placeholder="飞书群id" />
        <el-select v-model="pageIfon.error_log_type_main" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          />
        </el-select>
        <el-button icon="el-icon-search" type="primary" style="margin-left:10px" @click="(pageIfon.page = 1),(resultlist())">搜索</el-button>
        <el-button icon="el-icon-refresh-left" type="info" style="max-height:37px" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="typedialogVisible = true">类型配置</el-button>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
      </div>

    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="chat_id"
        label="飞书群id"
        width="300"
        align="center"
      />
      <el-table-column
        prop="error_log_type_main_text"
        label="类别"
        align="center"
      />
      <el-table-column
        prop="status"
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">
            <i class="el-icon-success defaultr" />
            正常
          </div>
          <div v-if="scope.row.status == 9">
            <i class="el-icon-delete stopew" />
            删除
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="chat_name"
        label="群聊名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="update_at_text"
        label="修改时间"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="loojser(2,scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="飞书"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <addanonydialog ref="addanonview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="类型配置"
      :visible.sync="typedialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <typeconfigdetils ref="typeconfig" @updata="updata" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { erroralarmList, delerroralarm, geterrortypeList } from '@/api/sourceMaterial.js'
import addanonydialog from './components/addanonydialog.vue'
import typeconfigdetils from './components/typeconfig.vue'
export default {
  name: 'Anonymousletter',
  components: {
    PaginationRight,
    addanonydialog,
    typeconfigdetils
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        page_size: 10,
        chat_id: null,
        error_log_type_main: null
      },
      total: null,
      tableData: [],
      id: null,
      dialogVisible: false,
      options: [],
      typedialogVisible: false
    }
  },
  created() {
    this.resultlist()
    this.typelist()
  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.id = val
      this.resultlist()
    },
    async resultlist() {
      const data = await erroralarmList({
        ...this.pageIfon
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    async typelist() {
      const data = await geterrortypeList()
      this.options = data.data
      console.log('data', data)
    },
    add(type) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addanonview.send(type)
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    loojser(type, item) {
      console.log(type, item)
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addanonview.send(type, item)
      })
    },
    reset() {
      this.pageIfon = {
        page: 1, // 页码
        page_size: 10, // 页数
        chat_id: null, // 用户openid
        error_log_type_main: null
      }
      this.resultlist()
    },
    updata() {
      this.dialogVisible = false
      this.resultlist()
    },
    deleter(id) {
      this.$confirm('确定要删除吗？是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delerroralarm({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.resultlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom:10px
}
</style>
